import { render, staticRenderFns } from "./MetricsList.vue?vue&type=template&id=a610eb78"
import script from "./MetricsList.vue?vue&type=script&lang=js"
export * from "./MetricsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a610eb78')) {
      api.createRecord('a610eb78', component.options)
    } else {
      api.reload('a610eb78', component.options)
    }
    module.hot.accept("./MetricsList.vue?vue&type=template&id=a610eb78", function () {
      api.rerender('a610eb78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/metrics/MetricsList.vue"
export default component.exports